/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       AccommodationDetailScreenStyle.ts
 * @author     Christian Ascone
 * @date       12/27/19 10:16 AM
 */

import {Platform, StyleSheet} from "react-native";
import Colors from "../../../config/Colors";
import {Header} from "react-navigation";
import Layout from "../../../config/Layout";

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.background,
        ...Platform.select({
            web: {
                height: Layout.window.height - Header.HEIGHT,
            },
        }),
    },
    scrollContainer: {
        flex: 1,
        backgroundColor: '#fff',
    },
    scrollOuter: {
        borderTopWidth: 0.5,
        borderTopColor: Colors.separatorColor,
        marginVertical: 20,
        padding: 10,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.15,
        shadowRadius: 3.84,

        elevation: 3,
        backgroundColor: "white" // invisible color
    },
    forgotPassword: {
        textAlign: 'right',
    },
    developmentModeText: {
        marginBottom: 20,
        color: 'rgba(0,0,0,0.4)',
        fontSize: 14,
        lineHeight: 19,
        textAlign: 'center',
    },
    contentContainer: {
        justifyContent: 'space-between',
    },
    welcomeContainer: {
        marginTop: 10,
        alignSelf: 'center',
    },
    inputContainer: {
        flex: 1,
        marginTop: 10,
        marginBottom: 20,
    },
    buttonContainer: {
        flex: 2,
        marginTop: 10,
        marginBottom: 20,
    },
    serviceSelectionContainer: {
        flexDirection: 'row',
        marginBottom: 20,
    },
    serviceBlock: {
        flex: 1,
        height: 50,
    },
    residentialBlock: {
        marginRight: 5,
    },
    publicBlock: {
        marginLeft: 5,
    },
    welcomeImage: {
        width: 150,
        height: 50,
        resizeMode: 'contain',
        marginTop: 3,
    },
    welcomeText: {
        flex: 1,
    },
    getStartedContainer: {
        height: '100%',
    },
    getStartedText: {
        fontSize: 17,
        color: Colors.textColor,
        lineHeight: 24,
        textAlign: 'center',
    },
    flex: {
        flex: 1,
    },
    doorSelection: {
        flex: 2,
    },
    deleteButtonContainer: {
        alignItems: 'flex-start',
        alignContent: 'flex-end',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        flex: 1,
    },
});

export default styles;